/** Converts literal `\n` sequences from CMS/API into real line breaks. */
export function formatMultilineText(text: string): string {
  return text.replace(/\\n/g, "\n");
}
